import React, { useState, useEffect } from "react";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import CountDisGraph from "./CountDisGraph";
import { Row } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../../../../msalConfig";
import { TELEMETRY_API } from "../../../../../../../constants/serverConfig";

const CountDisOverview = (props) => {
  const objectId = props.graphdata;

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };
  const getdetailsdata = () => {
    const HIST_GRAPH_API = `${TELEMETRY_API}metrics/historical?object_id=${objectId}&metric_key=${props.profile?.value}&runs=14`;
    setIsFetching(true);
    axios.get(HIST_GRAPH_API).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.objectId === `${objectId}`
      );
      let modaldata = _.map(filteriddata, (da) => {
        let unixupdatedate = moment.unix(da.batchDate);
        return {
          id: da.objectId,
          metricValue: da.metricValue,
          updatedAt: unixupdatedate.format("MMM D, YYYY"),
        };
      });

      setData(modaldata);
      setIsFetching(false);
    });
  };

  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getdetailsdata(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getdetailsdata(token);
          } catch (error) { }
        }
      }
    };
    fetchdatasets();
  }, [instance, props.profile]);

  return (
    <>
      {" "}
      <div className="justify-content-md-center">
        <Row className="py-3">
          <CountDisGraph data={data} fetching={isFetching} />
        </Row>
      </div>
    </>
  );
};

export default CountDisOverview;
